var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"justify-center d-flex align-center text-center",staticStyle:{"height":"calc(100vH - 70px)"}},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }